import axios from "axios";

class TeamService {
    getTeams() {
        return axios.get(`/team`);
    }

    addTeam(data) {
        return axios.post(`/team`, data);
    }

    delete(id) {
        return axios.delete(`/team/${id}`);
    }

    assignTeam(data) {
        return axios.post(`/team/assignTeam`, data);
    }

    removeFromTeam(data) {
        return axios.post(`/team/removeFromTeam`, data);
    }

    toggleTeamLeader(data) {
        return axios.post(`/team/toggleTeamLeader`, data);
    }

    getTeamLeaderTeams(data) {
        return axios.post(`/team/teamLeaderTeams`, data);
    }
}

export default new TeamService();